/**
 * Video Widget - YouTube iframe error handler
 */

document.addEventListener('DOMContentLoaded', function() {
    // Check for YouTube iframes
    const youtubeIframes = document.querySelectorAll('.video-wrapper iframe[src*="youtube.com"]');

    if (youtubeIframes.length > 0) {
        // Handle iframe load errors
        youtubeIframes.forEach(iframe => {
            iframe.addEventListener('error', function() {
                console.error('YouTube iframe failed to load');
                handleIframeError(iframe);
            });

            // Check if iframe is actually loaded after a delay
            setTimeout(() => {
                checkIframeLoaded(iframe);
            }, 3000);
        });
    }
});

/**
 * Check if iframe loaded successfully
 */
function checkIframeLoaded(iframe) {
    try {
        // Try to access iframe content to see if it's blocked
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

        // If we can't access it, it might be blocked by CSP
        if (!iframeDoc && iframe.clientHeight === 0) {
            console.warn('Iframe appears to be blocked, trying fallback');
            handleIframeError(iframe);
        }
    } catch (e) {
        // Cross-origin error is expected and means iframe loaded
        // Only handle if there's a different error
        if (e.name !== 'SecurityError' && iframe.clientHeight === 0) {
            console.error('Error accessing iframe:', e);
            handleIframeError(iframe);
        }
    }
}

/**
 * Handle iframe loading errors
 */
function handleIframeError(iframe) {
    const wrapper = iframe.closest('.video-wrapper');
    if (!wrapper) return;

    const videoId = wrapper.querySelector('.youtube-player')?.dataset?.id;
    if (!videoId) return;

    // Create error message with retry option
    const errorDiv = document.createElement('div');
    errorDiv.className = 'video-error';
    errorDiv.innerHTML = `
        <div style="padding: 40px; text-align: center; background: #f5f5f5; border-radius: 20px;">
            <p style="margin-bottom: 20px;">De video kan niet worden geladen.</p>
            <a href="https://www.youtube.com/watch?v=${videoId}" 
               target="_blank" 
               rel="noopener noreferrer"
               class="btn btn-primary"
               style="display: inline-block; padding: 10px 20px; background: #ff0000; color: white; text-decoration: none; border-radius: 4px;">
                Open video op YouTube
            </a>
        </div>
    `;

    // Replace iframe with error message
    wrapper.innerHTML = '';
    wrapper.appendChild(errorDiv);
}


